import { Autocomplete, CircularProgress, FormControl, FormLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { Stack } from '@mui/system';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import TPCheckbox from "../TemplateProperties/TPCheckbox";
import Tree from 'rc-tree';
import NewSubQuery from '../ContextMenu/NewSubQuery';
import { cloneDeep, debounce } from 'lodash';
import { eachDeep } from "deepdash-es/standalone";
import { api } from '../../redux/api';
import { getSelectedNodes } from '../RightContextMenu/ContextActions/CopyAndPaste';
import { treeActions } from '../../redux/slices/treeSlice';



function SubQuery() {
    const parentScreen = useContext(ParentScreenCtx);
    const { account, user } = useSelector(state => state.queryParams);
    const { rightTree, pdc } = useSelector((state) => state.treeData[parentScreen]);
    const currentTab = rightTree.currentTab;
    const translatedData = rightTree.tree[rightTree.currentTab].translatedData;
    const selectedNode = rightTree.tree[currentTab].selectedNode;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [tableDropdown, setTableDropdown] = useState([]);
    const [tableOptions, setTableOptions] = useState([]);
    const [table, setTable] = useState();
    const [columnDropdown, setColumnDropdown] = useState([]);
    const [columnOptions, setColumnOptions] = useState([]);
    const [column, setColumn] = useState('');
    const [comparatorDropdown, setComparatorDropdown] = useState();
    const [comparator, setComparator] = useState();
    const [recordOptions, setRecordOptions] = useState([]);
    const [recordDropdown, setRecordDropdown] = useState();
    const [record, setRecord] = useState();
    const [fieldOptions, setFieldOptions] = useState([]);
    const [fieldDropdown, setFieldDropdown] = useState();
    const [field, setField] = useState();
    const [value, setValue] = useState();
    const [quoteData, setQuoteData] = useState(false);
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const [disable, setDisable] = useState(true);
    const [currentNode, setCurrentNode] = useState();
    const tableLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['TABLE_LOADING']?.isLoading || false);
    const columnLoading = useSelector(state => state?.treeData?.[parentScreen]?.loadingState?.['COLUMN_LOADING']?.isLoading || false);
    const connectedPDC = useSelector(state => state?.treeData?.[parentScreen]?.connectedPDC);

    

    const submitChange = (node = []) => {
        let newData = cloneDeep(translatedData);
        const sortedNode = [...(node || [])].sort((a, b) => {
            const idxA = parseInt(String(a?.key || '').replace('query-link-', ''), 10) || 0;
            const idxB = parseInt(String(b?.key || '').replace('query-link-', ''), 10) || 0;
            return idxA - idxB;
        });
        let cleanData = cloneDeep(sortedNode).map((e) => {
            ['key', 'title', 'children', 'ICON_DISPLAY'].forEach((o) => {
                if(e?.hasOwnProperty(o)) delete e?.[o];
            })
            return e;
        });
        eachDeep(newData, (obj) => {
            if (obj?.key === selectedNode?.key) {
                obj['QUERY_LINK'] = cleanData;
                dispatch(
                    treeActions.setRightTreeSelectedNode({
                      screen: parentScreen,
                      type: rightTree.currentTab,
                      data: obj,
                    })
                );
            }
        });
        dispatch(treeActions.setNewRightTreeTranslatedData({
            screen: parentScreen,
            type: currentTab,
            data: newData
        }));
    }

    const comparatorOptions = [
        { value: '=', text: t('=') },
        { value: 'LIKE', text: t('LIKE') }
    ]
    
    const debounceChangeHandler = useCallback(debounce(submitChange, 10), [
        rightTree.currentTab,
        rightTree.tree,
    ]);
    
    const dataConversion = (values, initialRender) => {
        const newValues = values?.map(({ query, queryName }, index) => {
            return {
                key: `query-link-${index}`,
                title: queryName,
                TABLE_NAME: query?.TABLE_NAME,
                FIELD_NAME: query?.FIELD_NAME,
                COMPARE: query?.COMPARE,
                RECORD_TYPE: query?.RECORD_TYPE || query?.RECORD_NAME,
                MAPNAME: query?.MAPNAME,
                VALUE: query?.VALUE,
                QUOTE_DATA: query?.QUOTE_DATA,
                ICON_DISPLAY: 'QUERY',
                children: []
            }
        });
        setTreeData(newValues);
        if (initialRender && newValues?.length) {
            getNodeValues(newValues?.[0]); 
            setSelectedKeys([newValues?.[0]?.key])
        }
    }

    const onExpand = (keys) => {
        setExpandedKeys(keys);
    };

    const onSelect = (keys, detail) => {
        setSelectedKeys([detail.node.key]);
        setCurrentNode(detail?.node);
        getNodeValues(detail?.node)
    };

    const generateQueryString = (node) => {
        let query = '';
        if (node?.TABLE_NAME && node?.TABLE_NAME !== t('SELECT')) query += `${node?.TABLE_NAME || ''}`;
        if (node?.FIELD_NAME && node?.FIELD_NAME !== t('SELECT')) query = `${query}.${node?.FIELD_NAME || ''}`;
        if (node?.COMPARE) query = `${query} ${node?.COMPARE} `;
        if (node?.VALUE) {
            query = `${node?.TABLE_NAME || ''}.${node?.FIELD_NAME || ''} ${node?.COMPARE} ${node?.VALUE || ''}`;
        } else {
            if (node?.RECORD_NAME || node?.RECORD_TYPE) query = `${query}${node?.RECORD_NAME || node?.RECORD_TYPE || ''}`;
            if (node?.MAPNAME) query = `${query}.${node?.MAPNAME || 'null'}`;
        }
        if (!node?.TABLE_NAME || node?.TABLE_NAME === t('SELECT') || !node?.FIELD_NAME || node?.FIELD_NAME === t('SELECT')) 
            return t('INCOMPLETE_QUERY_LINK')
        return query;
    }

    const updateSubQuery = (key, val) => {
        // console.log(key, val);
        const node = treeData?.find((data) => data?.key === selectedKeys[0])
        if (node) {
            node[key] = val;
            let query = '';
            query = generateQueryString(node);
            if (query) node['title'] = query;
            const updatedData = treeData?.map((data) => {
                if (data?.key === node?.key) return node;
                else return data;
            });
            setTreeData(updatedData)
            debounceChangeHandler(updatedData)
            setCurrentNode(node);
        }
    } 

    const Icon = (node) => {
        return <span className={'tree-icon ' + node.ICON_DISPLAY}></span>
    }

    const getNodeValues = (node) => {
        if (node?.TABLE_NAME) {
            getColumnInfo(node.TABLE_NAME)
        }
        setTable(node?.TABLE_NAME || '');
        setColumn(node?.FIELD_NAME || '');
        setComparator(node?.COMPARE || '');
        setRecord(node?.RECORD_TYPE ||'');
        if (node?.RECORD_TYPE) {
            getFieldsForRecord(node?.RECORD_TYPE || '');
            setField(node?.MAPNAME || '');
        }else {
            setField('');
        }
        setValue(node?.VALUE || '');
        setQuoteData((node?.QUOTE_DATA === 'TRUE' || node?.QUOTE_DATA === true) ? true : false);
    }

    const getRecords = (rootNode) => {
        let records = [];
        const getRecord = (rootNode) => {
            if (rootNode?.key === 'ib-0') return records;
            else {
                let key = rootNode?.key?.split('-');
                key?.pop()
                key = key?.join('-');
                const node = getSelectedNodes([key], translatedData);
                if (node[0]?.ICON_DISPLAY === 'QUERY') records.push({title: node[0]?.title, key: node[0]?.key});
                getRecord(node[0]);
            }
        }
        getRecord(rootNode)
        return records;
    }

    const getField = (rootNode) => {
        const fields = [];
        const loopFields = (node) => {
            if (node?.children?.length === 0) return fields;
            else {
                node?.children?.map((child) => {
                    if (child?.ICON_DISPLAY === 'DATABASE_FIELD') {
                        fields.push(
                            { MAPNAME: child?.MAPNAME, key: child?.key, DESCRIPTION: child?.DESCRIPTION }
                        );
                    }
                    return null; 
                });
            }
        }
        loopFields(rootNode)
        return fields;
    }

    const getFieldsForRecord = (recordName) => {
        const recordToFind = recordOptions?.find((record) => record?.title === recordName)
        const node = getSelectedNodes([recordToFind?.key], translatedData);
        const fields = getField(node[0]);
        setFieldOptions(fields);
    }

    const addNewSubQuery = async () => {
        const newQuery = {
            key: `query-link-${treeData.length + 1}`,
            title: t('INCOMPLETE_QUERY_LINK'),
            TABLE_NAME: '',
            FIELD_NAME: '',
            COMPARE: '=',
            RECORD_TYPE: '',
            MAPNAME: '',
            VALUE: '',
            QUOTE_DATA: 'FALSE',
            ICON_DISPLAY: 'QUERY',
            children: []
        }
        const newQueries = [
            ...treeData
        ]
        newQueries.push(newQuery)
        setCurrentNode(newQuery)
        setTreeData(newQueries);
        debounceChangeHandler(newQueries);
        setDisable(false);
        setSelectedKeys([`query-link-${treeData.length + 1}`])
        getNodeValues(newQuery)
    }

    const getColumnInfo = (dbTable) => {
        if (!dbTable || dbTable === t('SELECT') || !tableOptions.length || !tableOptions.includes(dbTable)) return;
        const schema = selectedNode?.SCHEMA ? selectedNode?.SCHEMA : selectedNode?.CONNECTION === connectedPDC?.CONNECTION ? connectedPDC?.SCHEMA : ''
        
        const connection = selectedNode?.CONNECTION || connectedPDC?.CONNECTION;
        
        const columns = Object.keys(pdc?.[connection]?.[schema]?.[dbTable] || {});
        
        if (columns.length){
            setColumnOptions(columns)
        }else if (schema) {
            dispatch(treeActions.setLoadingActions({key: 'COLUMN_LOADING', data:{isLoading : true}}))
            dispatch(api.endpoints.get_database_column_info.initiate({
                account: account,
                user: user,
                table_name: dbTable,
                pdc_name : connection,
                schema_name : schema,
                direction: parentScreen === "inbound" ? "IN" : "OUT",
            }, {forceRefetch: true})
            ).then(response => {
                if (response.data.current_state === 'Success') {
                    setColumnOptions(response?.data?.data?.database_column_list)
                }
            })
        }
    }

    const updateIndex = (data) => {
        return data?.map((item, index) => {
            return {
                ...item, key: `query-link-${index}`
            }
        }) || [];
    }

    const deleteSubQuery = async () => {
        const updateData = treeData?.filter((data) => data?.key !== currentNode?.key)
        const newTreeData = updateIndex(updateData);
        setCurrentNode(newTreeData?.[newTreeData.length - 1] || {})
        if (updateData.length) setSelectedKeys([newTreeData?.[newTreeData.length - 1]?.key || ''])
        else setSelectedKeys([])
        getNodeValues(newTreeData?.[newTreeData.length - 1] || {})
        debounceChangeHandler(newTreeData);
        setTreeData(newTreeData);
    }

    useEffect(() => {
        const tempOptions = [...(tableOptions?.length ? [t('SELECT')] : [t('EMPTY_COMBO')]), ...tableOptions || []];
        const options = tempOptions?.map((obj, index) => {
            return obj;
        });
        setTableDropdown(options);
        getColumnInfo(table);
    }, [tableOptions]);

    useEffect(() => {
        const tempOptions = [...(columnOptions?.length ? [t('SELECT')] : [t('EMPTY_COMBO')]), ...columnOptions || []];
        const options = tempOptions?.map((obj, index) => {
            return obj;
        });
        setColumnDropdown(options);
    }, [columnOptions]);

    useEffect(() => {
        const options = comparatorOptions?.map((obj, key) => {
            return <MenuItem key={key} value={obj.value}>
                {obj.text}
            </MenuItem>
        });
        setComparatorDropdown(options);
    }, []);

    useEffect(() => {
        const tempOptions = [...(recordOptions?.length ? [{title: t('SELECT')}] : [{title: t('EMPTY_COMBO')}]), ...recordOptions || []];
        const options = tempOptions?.map((obj, i) => {
            return <MenuItem key={i} value={obj?.title}>
                {obj?.title}
            </MenuItem>
        });
        setRecordDropdown(options);
        getFieldsForRecord(treeData.find(e => e?.key === selectedKeys?.[0])?.RECORD_TYPE)
    }, [recordOptions]);

    useEffect(() => {
        const tempOptions = [...(fieldOptions?.length ? [{DESCRIPTION: t('SELECT')}] : [{DESCRIPTION: t('EMPTY_COMBO')}]), ...fieldOptions || []];
        const options = tempOptions?.map((obj, i) => {
            return <MenuItem key={i} value={obj?.DESCRIPTION || obj?.MAPNAME}>
                {obj?.DESCRIPTION || obj?.MAPNAME}
            </MenuItem>
        });
        setFieldDropdown(options);
    }, [fieldOptions]);

    useEffect(() => {
        const arr = [];
        if (selectedNode?.QUERY_LINK) {
            setDisable(false);
            for (let i = 0; i < selectedNode?.QUERY_LINK?.length; i++) {
                const query = selectedNode?.QUERY_LINK[i];
                const newQuery = {
                    query,
                    queryName: generateQueryString(query)
                }
                arr.push(newQuery);
            }
        } else setDisable(true);
        setTable('');
        setColumn('');
        setComparator('');
        setRecord('');
        setField('');
        setValue('');
        setQuoteData(false)
        setRecordOptions(getRecords(selectedNode));
        setSelectedKeys([])
        dataConversion(arr, true);
        return () => {
            setTableOptions([]);
            setColumnOptions([]);
        }
    }, [selectedNode?.key]);
    
    useEffect(() => {
        
        // Determine the schema to use
        let schema = '';
        if (selectedNode?.SCHEMA) {
            schema = selectedNode.SCHEMA;
        } else if (connectedPDC?.SCHEMA) {
            schema = connectedPDC.SCHEMA;
        }
        
        
        // Determine the connection to use
        let connection = '';
        if (selectedNode?.CONNECTION) {
            connection = selectedNode.CONNECTION;
        } else if (connectedPDC?.CONNECTION) {
            connection = connectedPDC.CONNECTION;
        }
        
        
        // Get tables from PDC data
        if (connection && schema && pdc?.[connection]?.[schema]) {
            const tables = Object.keys(pdc[connection][schema] || {});  
            setTableOptions(tables);
        } else {
            if (pdc && (connection || schema)) {
                setTableOptions([]);
            }
        }
    }, [pdc, selectedNode?.CONNECTION, selectedNode?.SCHEMA, connectedPDC]);
   
    return (
        <>
            {selectedNode?.key?.split('-')?.length !== 3 ?

                <Stack spacing={'10px'} padding={'2px'} className="tp-segment">
                    <FormLabel>{t("LBL_SUB_QUERY_LINK")}</FormLabel>
                    <div className='div-textbox' id="subquery">
                        {treeData?.length ? <Tree
                            onExpand={(keys, detail) => onExpand(keys, detail)}
                            onSelect={(keys, detail) => onSelect(keys, detail)}
                            treeData={treeData}
                            icon={Icon}
                            selectedKeys={selectedKeys}
                            expandedKeys={expandedKeys}
                            showIcon
                            selectable={true}
                        /> : ''}
                        <NewSubQuery onCreateNewSubQuery={addNewSubQuery} onDeleteSubQuery={deleteSubQuery} disable={disable} />
                    </div>
                    <FormControl variant="outlined" className="width-100" size="small">
                        <Autocomplete
                            disabled={!selectedKeys.length || tableLoading}
                            size="small"
                            freeSolo
                            variant="outlined"
                            className='width-100'
                            options={tableDropdown}
                            inputValue={table || ''}
                            name={'TABLE_NAME'}
                            value={table || ''}
                            labelId="dbColumnLabel"
                            label={t("LBL_TABLE_NAME")}
                            id="columnDropdown"
                            onInputChange={(event, newInputValue) => {
                                setTable(newInputValue);
                                updateSubQuery('TABLE_NAME', newInputValue);
                                getColumnInfo(newInputValue);
                                setColumnOptions([]);
                            }}
                            onChange={(event, newValue) => {
                                const value = [t('SELECT'), t('EMPTY_COMBO')].includes(newValue) ? '' : newValue
                                setTable(newValue || '');
                                updateSubQuery('TABLE_NAME',value || '');
                                getColumnInfo(value);
                            }}
                            renderInput={(params) => <TextField 
                                disabled={!selectedKeys.length || columnLoading || tableLoading}
                                size="small" 
                                variant="outlined" 
                                {...params} 
                                label={t("LBL_TABLE_NAME")}
                                value={column}
                                onChange={(e) => {
                                    setTable(e.target.value);
                                    updateSubQuery('TABLE_NAME', e.target.value);
                                    getColumnInfo(e.target.value);
                                    setColumnOptions([]);
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: tableLoading ? <CircularProgress size={"14px"} /> : params.InputProps.endAdornment
                                    
                                }}
                            />}
                        />
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small" >
                        <Autocomplete
                            disabled={!selectedKeys.length || columnLoading || tableLoading}
                            size="small"
                            variant="outlined"
                            freeSolo
                            className='width-100'
                            options={columnDropdown}
                            inputValue={column || ''}
                            name={'COLUMNNAME'}
                            value={column || ''}
                            labelId="dbColumnLabel"
                            label={t("DB_NAV_COLUMN_NAME")}
                            id="columnDropdown"
                            onInputChange={(event, newInputValue) => {
                                updateSubQuery('FIELD_NAME', newInputValue)
                                setColumn(newInputValue);
                            }}
                            onChange={(event, newValue) => {
                                const value = [t('SELECT'), t('EMPTY_COMBO')].includes(newValue) ? '' : newValue
                                setColumn(newValue || '');
                                updateSubQuery("FIELD_NAME", value || '');
                            }}
                            renderInput={(params) => <TextField 
                                disabled={!selectedKeys.length || columnLoading || tableLoading}
                                size="small" 
                                variant="outlined" 
                                {...params} 
                                label={t("LBL_COL_NM")}
                                value={column}
                                onChange={(e) => {
                                    setColumn(e.target.value);
                                }}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: columnLoading ? <CircularProgress size={"14px"} /> : params.InputProps.endAdornment
                                    
                                }}
                            />}
                        />
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small" disabled={disable}>
                        <InputLabel id="comparatorLabel">{t("LBL_COMPARATOR")}</InputLabel>
                        <Select
                            disabled={!selectedKeys.length}
                            className={"width-100"}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name={'COMPARE'}
                            value={comparator || '='}
                            labelId="comparatorLabel"
                            label={t("LBL_COMPARATOR")}
                            id="comparatorDropdown"
                            onChange={(e) => {
                                setComparator(e.target.value);
                                updateSubQuery("COMPARE", e.target.value);
                                // debounceChangeHandler("COMPARE", e.target.value);
                            }}>
                            {comparatorDropdown}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small" disabled={disable}>
                        <InputLabel id="recordLabel">{t("LBL_REC_NAME")}</InputLabel>
                        <Select
                            disabled={!selectedKeys.length}
                            className={"width-100"}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name={'RECORD'}
                            value={record || ''}
                            labelId="recordLabel"
                            label={t("LBL_REC_NAME")}
                            id="recordDropdown"
                            onChange={(e) => {
                                const value = [t('SELECT'), t('EMPTY_COMBO')].includes(e.target.value) ? '' : e.target.value
                                setRecord(e.target.value);
                                getFieldsForRecord(value);
                                updateSubQuery("RECORD_TYPE", value);
                                // debounceChangeHandler("RECORD_NAME", e.target.value);
                            }}>
                            {recordDropdown}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className="width-100" size="small" disabled={disable}>
                        <InputLabel id="fieldLabel">{t("LBL_FLD_NAME")}</InputLabel>
                        <Select
                            disabled={!selectedKeys.length}
                            className={"width-100"}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        maxHeight: 300,
                                    },
                                },
                            }}
                            name={'FIElD'}
                            value={field || ''}
                            labelId="fieldLabel"
                            label={t("LBL_FLD_NAME")}
                            id="fieldDropdown"
                            onChange={(e) => {
                                const value = [t('SELECT'), t('EMPTY_COMBO')].includes(e.target.value) ? '' : e.target.value
                                setField(e.target.value);
                                updateSubQuery("MAPNAME", value);
                            }}>
                            {fieldDropdown}
                        </Select>
                    </FormControl>
                    <FormControl className="width-100" size="small">
                        <TextField
                            disabled={!selectedKeys.length || disable}
                            variant="outlined"
                            size="small"
                            autoComplete="off"
                            type="text"
                            className={"width-100"}
                            label={t('FRG_VALUE_')}
                            name={'VALUE'}
                            value={value || ''}
                            onChange={(e) => {
                                setValue(e.target.value);
                                updateSubQuery("VALUE", e.target.value);
                                // debounceChangeHandler("VALUE", e.target.value);
                            }}
                        />
                    </FormControl>
                    <TPCheckbox
                        label={t('BTN_QUOTE_DATA')}
                        disabled={!selectedKeys?.length || disable}
                        checked={quoteData}
                        handleCheck={(checked) => {
                            setQuoteData(checked);
                            updateSubQuery("QUOTE_DATA", checked);
                        }} />
                </Stack>
                : ""
            }
        </>
    )
}

export default SubQuery